/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { WhatsAppSolutionAssociationVerificationSource } from './WhatsAppSolutionAssociationVerificationSource';
/**
 * Conclusive evidence contradicting the requested Meta solution association.
 */
export type WhatsAppSolutionAssociationMismatch = {
    /**
     * Meta signal used to classify the solution association.
     */
    source: WhatsAppSolutionAssociationVerificationSource;
    /**
     * Solution identifier expected for this onboarding attempt.
     */
    expectedSolutionId: string;
    /**
     * Whether the expected solution association should be present.
     */
    expectedPresent: boolean;
    /**
     * ISO timestamp when the evidence was checked.
     */
    checkedAt: string;
    /**
     * Evidence classification.
     */
    status: WhatsAppSolutionAssociationMismatch.status;
    /**
     * Whether Meta reported the expected solution association as present.
     */
    observedPresent: boolean;
};
export namespace WhatsAppSolutionAssociationMismatch {
    /**
     * Evidence classification.
     */
    export enum status {
        MISMATCH = 'mismatch',
    }
}

